// extracted by mini-css-extract-plugin
module.exports = {"clickable":"R63rs","upper":"m0L1D","lower":"AAGnj"};